

import React from 'react'

import { CheckIcon } from '@radix-ui/react-icons';

import * as Checkbox from '@radix-ui/react-checkbox';
import clsx from 'clsx';

import styleClasses from './Checkbox.module.css';

export default function Checkbox_comp({ checked, onChange, color = "main", isDisabled, className }) {

    const enabledClass = styleClasses["enabled"];
    return (
        <Checkbox.Root className={clsx(styleClasses["lc-checkbox"], className, { "cursor-not-allowed opacity-60 ": isDisabled, [enabledClass]: !isDisabled })} 
            checked={checked} onCheckedChange={onChange} disabled={isDisabled} data-color={color}>
            <Checkbox.Indicator className={styleClasses["CheckboxIndicator"]}>
                <CheckIcon />
            </Checkbox.Indicator>
        </Checkbox.Root>
    )
}
